import { ErrorHandler, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import {
    AppComponent,
    LoginModule,
    SharedModule,
    DbLookUpService,
    HelperRtnsComponent,
    WebsocketService,
    PaymentService,
    CkRegisterComponent,
    CkRegisterDetailComponent,
    ReclXmlMedicareBReterminationComponent,
    CkRegisterPipe,
    CkRegister835DetailComponent,
    AppToastsContainer,
    AppToastsService,
    CacheInterceptor,
    CasSeqNoPipe,
    NgxPaginationModule,
    CasFoundPipe,
    CkRegisterDetailModalHeaderComponent,
    DetPcodeFilterPipe,
    BrowserAnimationsModule,
    McFilterPipe,
    CommonModule,
    MatSidenavModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatDatepickerModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatTableModule,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    MatChipsModule,
    MatFormFieldModule,
    MatSortModule,
    MatCheckboxModule,
    ReclMedicarePartBRedeterminationFcsoComponent,
    RptAgingComponent,
    RptDtxComponent,
    RptDtxDetailComponent,
    RptDtxPaymentComponent,
    ReportsComponent,
    RptAgingClaimsComponent,
    RptAgingDetailsComponent,
    NgbModule,
    OverlayModule,
    NgxPopperjsModule,
    NgbActiveModal,
    HTTP_INTERCEPTORS,
    ReclaimComponent,
    Json2Pipe,
    GlobalErrorHandlerService,
    RptEspCobComponent,
    RptEspCobClmComponent,
    RptEspCobDetComponent,
    RptEspCobPayComponent,
    RptIncomeComponent,
    ScrollingModule
} from './index';

@NgModule({
    imports: [
        BrowserModule,
        LoginModule,
        SharedModule,
        RouterModule,
        NgbModule,
        OverlayModule,
        NgxPaginationModule,
        NgxPopperjsModule,
        BrowserAnimationsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatSidenavModule,
        MatListModule,
        MatCardModule,
        MatButtonModule,
        MatDatepickerModule,
        MatInputModule,
        MatSelectModule,
        MatTooltipModule,
        MatTableModule,
        MatToolbarModule,
        MatIconModule,
        MatMenuModule,
        MatChipsModule,
        MatFormFieldModule,
        MatSortModule,
        MatCheckboxModule,
        ReclaimComponent,
        Json2Pipe,
        ScrollingModule
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        PaymentService,
        DbLookUpService,
        HelperRtnsComponent,
        WebsocketService,
        NgbActiveModal,
        AppToastsService,
        { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
        { provide: ErrorHandler, useClass: GlobalErrorHandlerService }
    ],
    declarations: [
        AppComponent,
        CkRegisterComponent,
        CkRegisterDetailComponent,
        ReclXmlMedicareBReterminationComponent,
        CkRegisterPipe,
        CkRegister835DetailComponent,
        CasSeqNoPipe,
        AppToastsContainer,
        CkRegisterDetailModalHeaderComponent,
        CasFoundPipe,
        DetPcodeFilterPipe,
        McFilterPipe,
        ReclMedicarePartBRedeterminationFcsoComponent,
        ReportsComponent,
        RptAgingComponent,
        RptAgingClaimsComponent,
        RptAgingDetailsComponent,
        RptDtxComponent,
        RptDtxDetailComponent,
        RptDtxPaymentComponent,
        RptEspCobComponent,
        RptEspCobClmComponent,
        RptEspCobDetComponent,
        RptEspCobPayComponent,
        RptIncomeComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
